import { defineStore } from 'pinia'
// import axios from 'axios'

const initialState = {
  drawer: false,
  menuActiveIndex: false
}
export default defineStore('navigation', {
  state: () => initialState,
  actions: {},
  persist: true
})
